import React from "react";
import { useQuery } from "@tanstack/react-query";

import { countExclusivityConflicts, ExclusivityCheckFields } from "./utils";

interface UseExclusivityCheckFieldsParams {
  fields: ExclusivityCheckFields
  exclusivityClause: server.dto.ExclusivityClause
}

export const useExclusivityCheckFields = (params: UseExclusivityCheckFieldsParams) => {
  const { fields, exclusivityClause } = params;

  return React.useMemo(() => ({
    ...fields,
    exclusivityClause,
  }), [
    fields.artistId,
    fields.excludeShowId,
    fields.showStartDisplay.valueOf(),
    fields.showEndDisplay.valueOf(),
    fields.venueLocation?.lat,
    fields.venueLocation?.lng,
    fields.venueId,
    fields.appointmentPhase,
    exclusivityClause?.daysAfter,
    exclusivityClause?.daysBefore,
    exclusivityClause?.radius,
    exclusivityClause?.unitOfDistance,
  ]);
}

interface UseExclusivityConflictCountParams {
  exclusivityCheckFields: ExclusivityCheckFields
}

export const useExclusivityConflictCount = (params: UseExclusivityConflictCountParams) => {
  const { exclusivityCheckFields } = params;

  return useQuery(
    ["exclusivity-conflict-count", exclusivityCheckFields],
    () => countExclusivityConflicts(exclusivityCheckFields, false),
  );
}
